import type * as Types from 'app/types/graphql';

import {
  ThemePageSelectFragmentDoc,
  ThemePageMetaSelectFragmentDoc,
  ThemePageParentSelectFragmentDoc,
} from '../fragments/themePage.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePagesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.ThemePageOrder>;
  where?: Types.InputMaybe<Types.ThemePageWhereInput>;
}>;

export type ThemePagesQueryResponse = {
  themePages?: Types.Maybe<
    Pick<Types.ThemePageConnection, 'totalCount'> & {
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<Types.ThemePageEdge, 'cursor'> & {
              node?: Types.Maybe<
                Pick<
                  Types.ThemePage,
                  | 'id'
                  | 'name'
                  | 'type'
                  | 'default'
                  | 'isGlobal'
                  | 'status'
                  | 'updatedAt'
                  | 'publishedAt'
                  | 'handle'
                > & {
                  metafields?: Types.Maybe<
                    Array<
                      Types.Maybe<
                        Pick<
                          Types.ThemePageMeta,
                          'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'
                        >
                      >
                    >
                  >;
                  parent?: Types.Maybe<
                    Pick<Types.ThemePage, 'id' | 'name' | 'type' | 'status' | 'default'>
                  >;
                }
              >;
            }
          >
        >
      >;
      pageInfo: Pick<
        Types.PageInfo,
        'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
      >;
    }
  >;
};

export const ThemePagesDocument = `
    query ThemePages($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: ThemePageOrder, $where: ThemePageWhereInput) {
  themePages(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      cursor
      node {
        ...ThemePageSelect
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${ThemePageSelectFragmentDoc}
${ThemePageMetaSelectFragmentDoc}
${ThemePageParentSelectFragmentDoc}`;

export const useThemePagesQuery = <TData = ThemePagesQueryResponse, TError = unknown>(
  variables?: ThemePagesQueryVariables,
  options?: UseQueryOptions<ThemePagesQueryResponse, TError, TData>,
) => {
  return useQuery<ThemePagesQueryResponse, TError, TData>(
    variables === undefined ? ['ThemePages'] : ['ThemePages', variables],
    appFetcher<ThemePagesQueryResponse, ThemePagesQueryVariables>(ThemePagesDocument, variables),
    options,
  );
};

useThemePagesQuery.getKey = (variables?: ThemePagesQueryVariables) =>
  variables === undefined ? ['ThemePages'] : ['ThemePages', variables];
